/**
 * Tarifas y constantes de costo para el dashboard "Control de Costos AWS"
 * del Canal Web Reconocimiento. Fuente: PROPUESTA-COSTOS-AWS-RECONOCIMIENTO.md
 * y propuesta-260526135.pdf (verificados contra el código real en julio 2026).
 *
 * Revisar TIPO_CAMBIO_GTQ_USD trimestralmente (referencia Banguat).
 */

export const TIPO_CAMBIO_GTQ_USD = 7.75;

export const COSTO_AWS = {
  rekognitionImagenPorLlamada: 0.001, // USD por llamada (DetectLabels/DetectText/CompareFaces)
  llamadasRekognitionPorGestion: 6, // DetectLabels x2, DetectText x3, CompareFaces x1
  faceLivenessPorCheck: 0.012, // USD por check completo (CreateSession+streaming+GetResults)
  cloudWatchFijoMensual: 1.0, // USD/mes, no depende del volumen
};

export const COSTO_OTP_POR_CANAL = {
  email: 0,
  whatsapp: 0.006,
  sms: 0.0075,
};

// Mix asumido en el documento interno — solo para comparar contra el mix real observado.
export const MIX_OTP_ASUMIDO_DOCUMENTO = {
  email: 0.35,
  whatsapp: 0.4,
  sms: 0.25,
};

// Planes del PDF comercial (Data Kalan -> Grupo Cosmético Global). Cobra por
// evaluación INICIADA (incluso abandonada), en Quetzales.
export const PLANES_PDF_COMERCIAL = [
  {
    nombre: 'Básico',
    limiteEvaluaciones: 200,
    tarifaBaseGTQ: 700,
    tarifaAdicionalGTQ: 3.5,
  },
  {
    nombre: 'Profesional',
    limiteEvaluaciones: 500,
    tarifaBaseGTQ: 1500,
    tarifaAdicionalGTQ: 3.0,
  },
  {
    nombre: 'Empresarial',
    limiteEvaluaciones: 1000,
    tarifaBaseGTQ: 2800,
    tarifaAdicionalGTQ: 2.5,
  },
];

// Modelo interno (documento PROPUESTA-COSTOS-AWS-RECONOCIMIENTO.md). Cobra
// sobre gestiones COMPLETADAS, en USD, plano hasta el límite base + tramos de excedente.
export const MODELO_INTERNO = {
  baseUSD: 105.0,
  limiteBase: 3500,
  tramos: [
    { desde: 3501, hasta: 5000, tarifaPorGestionUSD: 0.032 },
    { desde: 5001, hasta: 10000, tarifaPorGestionUSD: 0.027 },
  ],
};
